// extracted by mini-css-extract-plugin
module.exports = {"headline":"CollectionFilters_headline__nGskt","categories":"CollectionFilters_categories__XfmEZ"};